module.exports = __webpack_public_path__ + "static/media/fc-t1.06640dc6.svg";